import type { Resource } from '../../';
export const general_errors_seeStacktrace: Resource = {"default":"See stacktrace"};
